import React, { useMemo } from 'react';
import JsonLd from './JsonLd';
import {
  SITE_NAME,
  DEFAULT_DESCRIPTION,
  CONTACT_EMAIL,
  getSiteOrigin,
} from '../lib/siteMeta';

/** Organisation + WebSite sur toutes les pages (référence pour les autres schémas @id). */
export default function GlobalSiteJsonLd() {
  const data = useMemo(() => {
    const origin = getSiteOrigin();
    const orgId = `${origin}/#organization`;
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'EducationalOrganization',
        '@id': orgId,
        name: SITE_NAME,
        url: origin,
        email: CONTACT_EMAIL,
        description: DEFAULT_DESCRIPTION,
        areaServed: { '@type': 'Country', name: 'France' },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE_NAME,
        url: `${origin}/`,
        inLanguage: 'fr-FR',
        publisher: { '@id': orgId },
      },
    ];
  }, []);

  return <JsonLd data={data} />;
}
